import type { AuthError } from '@supabase/supabase-js';

type Mode = 'signin' | 'signup';

export type TranslatedAuthError = {
  message: string;
  suggestSignin?: boolean;
};

export function translateAuthError(err: AuthError | Error, mode: Mode): TranslatedAuthError {
  const raw = (err.message || '').toLowerCase();

  if (mode === 'signin') {
    if (raw.includes('invalid login credentials') || raw.includes('invalid_credentials')) {
      return { message: 'E-mail ou senha incorretos. Verifique os dados e tente novamente.' };
    }
    if (raw.includes('email not confirmed')) {
      return {
        message:
          'Seu e-mail ainda não foi confirmado. Verifique sua caixa de entrada e a pasta de spam.',
      };
    }
    if (raw.includes('too many requests') || raw.includes('rate limit')) {
      return {
        message: 'Muitas tentativas em sequência. Aguarde alguns instantes antes de tentar novamente.',
      };
    }
    if (raw.includes('email logins are disabled')) {
      return { message: 'O login por e-mail está temporariamente indisponível.' };
    }
    return { message: 'Não foi possível entrar no momento. Tente novamente em instantes.' };
  }

  if (raw.includes('user already registered') || raw.includes('already been registered')) {
    return {
      message: 'Este e-mail já possui uma conta cadastrada.',
      suggestSignin: true,
    };
  }
  if (raw.includes('unable to validate email') || raw.includes('invalid email') || raw.includes('invalid format')) {
    return { message: 'O e-mail informado é inválido. Verifique o formato e tente novamente.' };
  }
  const lengthMatch = err.message?.match(/at least (\d+)/i);
  if (raw.includes('password should be at least') || raw.includes('password is too short')) {
    return {
      message: lengthMatch
        ? `A senha deve ter pelo menos ${lengthMatch[1]} caracteres.`
        : 'A senha não atende ao tamanho mínimo exigido.',
    };
  }
  if (raw.includes('signup requires a valid password')) {
    return { message: 'Informe uma senha para criar a conta.' };
  }
  if (raw.includes('signup is disabled') || raw.includes('signups not allowed')) {
    return { message: 'O cadastro está temporariamente indisponível.' };
  }
  return { message: 'Não foi possível criar a conta no momento. Tente novamente em instantes.' };
}
